import React, { useState } from "react";
import {
  Button,
  Card,
  CardBody,
  Col,
  Collapse,
  FormGroup,
  Input,
  Label,
} from "reactstrap";
import logo from "./Images/autodesk.png";

const InventorControlPanel = () => {
  const baseUrl = "http://localhost:5000";

  const [agentStatus, setAgentStatus] = useState("...");
  const [invStatus, setInvStatus] = useState("...");

  const [drawc, setDrawC] = useState(); //circle
  const [width, setWidth] = useState("");
  const [height, setHeight] = useState("");
  //rectangel

  const [isOpen, setIsOpen] = useState(false);
  const toggle = () => setIsOpen(!isOpen);

  const downloadAgent = async () => {
    try {
      const res = await fetch(`${baseUrl}/status-inventor`);
      if (res.ok) {
        setAgentStatus("✅ Agent is already running.");
        return;
      }
    } catch {
      // Agent not running
    }

    // Proceed to download
    const link = document.createElement("a");
    link.href =
      "https://feesworth-my.sharepoint.com/:u:/p/sengamuthu_periyasamy/EUGfUS0j4vhOhCsRPD9fVs4BdYOmDIq56uHccpqo8fFDlw?e=TbSTEv";
    link.target = "_blank";
    link.download = "Agent.exe";
    document.body.appendChild(link);
    link.click();
  };

  const checkAgent = async () => {
    try {
      const res = await fetch(`${baseUrl}/status-inventor`);
      if (res.ok) {
        setAgentStatus("✅ Agent is running on localhost.");
      } else {
        setAgentStatus("⚠️ Agent responded with an error.");
      }
    } catch {
      setAgentStatus(
        "❌ Could not connect to agent. Please ensure it is running."
      );
    }
  };

  const checkInventor = async () => {
    try {
      const res = await fetch(`${baseUrl}/status-inventor`);
      const data = await res.json();
      setInvStatus(
        data.installed
          ? "✅ Autodesk Inventor is installed."
          : "❌ Autodesk Inventor is not found."
      );
    } catch {
      setInvStatus("⚠️ Could not connect to local agent.");
    }
  };

  const launchInventor = async () => {
    try {
      const res = await fetch(`${baseUrl}/launch-inventor`);
      const data = await res.json();
      setInvStatus(
        data.launched
          ? "✅ Inventor launched successfully!"
          : "❌ Failed to launch Inventor / Install Inventor."
      );
    } catch {
      setInvStatus("⚠️ Could not connect to local agent.");
    }
  };

  const drawCircle = async () => {
    try {
      const res = await fetch(`${baseUrl}/draw-circle`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ diameter: parseFloat(drawc) }),
      });
      const data = await res.json();

      if (data.success) {
        alert("✅ Circle drawn successfully in Inventor!");
      } else {
        alert(`❌ Failed to draw circle: ${data.error}`);
      }
    } catch (err) {
      alert("⚠️ Could not connect to local agent.");
    }
  };

  const drawRectangle = async () => {
    try {
      const res = await fetch(`${baseUrl}/draw-rectangle`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          width: parseFloat(width),
          height: parseFloat(height),
        }),
      });

      const data = await res.json();

      if (data.success) {
        alert("✅ Rectangle drawn successfully in Inventor!");
      } else {
        alert(`❌ Failed to draw rectangle: ${data.error}`);
      }
    } catch (err) {
      alert("⚠️ Could not connect to local agent.");
    }
  };

  return (
    <>
      <Card
        className=""
        style={{
          width: "60%",
          margin: "0 auto",
          padding: "25px",
          marginTop: "50px",
        }}
      >
        <div className="d-flex align-items-center justify-content-center">
          <img src={logo} alt="autodesk" width="25%" />
          <h3>Inventor Control Panel</h3>
        </div>

        {/* <h5>Download center</h5> */}
        <div className="download">
          <Button
            color="info"
            outline
            className="btndwn"
            onClick={downloadAgent}
            style={{ width: "auto" }}
          >
            ⬇️ Download Agent
          </Button>
          <Button
            color="info"
            outline
            className="btncheck"
            onClick={checkAgent}
            style={{ width: "auto" }}
          >
            🔍 Check Agent Status
          </Button>
        </div>

        <div className="status">{agentStatus}</div>

        <hr />

        {/* Inventor Controls */}
        <div className="launch">
          <Button
            color="info"
            outline
            className="btncheck"
            onClick={checkInventor}
            style={{ width: "auto" }}
          >
            🔍 Check Inventor
          </Button>
          <Button
            color="success"
            outline
            className="btnlaunch"
            onClick={launchInventor}
            style={{ width: "auto" }}
          >
            Launch Inventor
          </Button>
        </div>
        <div className="status">{invStatus}</div>
      </Card>

      <div className="formheader">
        <Button onClick={toggle}>Open Form</Button>

        <Collapse isOpen={isOpen}>
          <Card className="dia-form">
            <CardBody>
              <FormGroup row>
                <Label sm={6} md={4}>
                  Enter diameter value (mm):
                </Label>
                <Col sm={6} md={4}>
                  <Input
                    type="number"
                    value={drawc || ""}
                    onChange={(e) => setDrawC(e.target.value)}
                    placeholder="e.g., 100"
                  />
                </Col>
                <Col sm={6} md={4}>
                  <Button color="primary" onClick={drawCircle}>
                    🟠 Draw Circle
                  </Button>
                </Col>
              </FormGroup>
            </CardBody>

            <CardBody>
              <h5 className="mb-3">Draw Rectangle</h5>
              <FormGroup row>
                <Label sm={6} md={4}>
                  Width (mm):
                </Label>
                <Col sm={6} md={4}>
                  <Input
                    type="number"
                    value={width}
                    onChange={(e) => setWidth(e.target.value)}
                    placeholder="e.g., 100"
                  />
                </Col>
              </FormGroup>

              <FormGroup row>
                <Label sm={6} md={4}>
                  Height (mm):
                </Label>
                <Col sm={6} md={4}>
                  <Input
                    type="number"
                    value={height}
                    onChange={(e) => setHeight(e.target.value)}
                    placeholder="e.g., 50"
                  />
                </Col>
              </FormGroup>

              <FormGroup row>
                <Col sm={{ size: 6, offset: 4 }} md={{ size: 4, offset: 4 }}>
                  <Button color="primary" onClick={drawRectangle}>
                    📐 Draw Rectangle
                  </Button>
                </Col>
              </FormGroup>
            </CardBody>
          </Card>
        </Collapse>
      </div>
    </>
  );
};

export default InventorControlPanel;
